export type FaTaskStatus = 'To Do' | 'In Progress' | 'Done' | 'Blocked' | 'Withdrawn';
export type FaTaskPriority = 'P1' | 'P2' | 'P3' | 'P4';
export type FaTaskRecurrence = 'none' | 'daily' | 'weekly' | 'monthly' | 'custom';
export type FaTaskDueDateFilter = 'all' | 'today' | 'next7' | 'overdue';
export type FaTaskSortBy = 'dueDate' | 'priority' | 'createdDate' | 'updatedDate';

export interface FaSubtask {
  id: string;
  title: string;
  done: boolean;
}

export interface FaTask {
  id: string;
  taskName: string;
  description: string;
  opportunityId: string | null;
  assignee: string;
  priority: FaTaskPriority;
  status: FaTaskStatus;
  labels: string[];
  subtasks: FaSubtask[];
  recurrence: FaTaskRecurrence;
  recurrenceCustomText?: string;
  createdDate: string;
  updatedDate: string;
  dueDate: string;
  plannedDate: string;
}

export interface FaTasksState {
  tasks: FaTask[];
}
